"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderMenuLists = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var list_1 = require("../../list");
var tips_1 = require("../../tips");
var noop_1 = require("../../_util/noop");
var use_isomorphic_layout_effect_1 = require("../../_util/use-isomorphic-layout-effect");
var CascaderBox_1 = require("../CascaderBox");
var CascaderLoading_1 = require("../CascaderLoading");
function CascaderMenuLists(_a) {
    var data = _a.data, curValue = _a.curValue, onLoad = _a.onLoad, onClose = _a.onClose, changeOnSelect = _a.changeOnSelect, onSelect = _a.onSelect, expandTrigger = _a.expandTrigger, scheduleUpdate = _a.scheduleUpdate, tips = _a.tips, bottomTips = _a.bottomTips, _b = _a.onScrollBottom, onScrollBottom = _b === void 0 ? noop_1.noop : _b;
    var enterTimerRef = react_1.useRef(null);
    // 面板可用值（动态加载时预先传输 value 场景，此时值无法和面板数据对应）
    var availableValue = react_1.useMemo(function () {
        var _a, _b;
        var lists = [data];
        var value = [];
        var _loop_1 = function (i) {
            var option = (_b = (_a = lists[i]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find(function (option) { return option.value === curValue[i]; });
            if (option) {
                value.push(curValue[i]);
            }
            if (option && option.child) {
                lists.push(option.child);
            }
            else {
                return "break";
            }
        };
        for (var i = 0; i < (curValue === null || curValue === void 0 ? void 0 : curValue.length); ++i) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        return value;
    }, [curValue, data]);
    // 内部状态
    var _c = tslib_1.__read(react_1.useState(availableValue || []), 2), internalValue = _c[0], setInternalValue = _c[1];
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        setInternalValue(availableValue || []);
    }, [curValue]);
    var lists = react_1.useMemo(function () {
        var _a, _b;
        var lists = [data];
        var _loop_2 = function (i) {
            var option = (_b = (_a = lists[i]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find(function (option) { return option.value === internalValue[i]; });
            if (option && option.child) {
                lists.push(option.child);
            }
            else {
                return "break";
            }
        };
        for (var i = 0; i < internalValue.length; ++i) {
            var state_2 = _loop_2(i);
            if (state_2 === "break")
                break;
        }
        return lists;
    }, [data, internalValue]);
    react_1.useEffect(function () {
        if (scheduleUpdate) {
            scheduleUpdate();
        }
    }, [lists, scheduleUpdate]);
    function handleSelect(index, value, _a) {
        var event = _a.event, hasChild = _a.hasChild;
        var newValue = tslib_1.__spread(internalValue.slice(0, index), [value]);
        if (changeOnSelect) {
            onSelect(newValue, { event: event, options: CascaderBox_1.getOptions(data, newValue) });
        }
        else {
            setInternalValue(newValue);
            if (!hasChild) {
                onSelect(newValue, { event: event, options: CascaderBox_1.getOptions(data, newValue) });
            }
        }
        if (!hasChild) {
            onClose();
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, lists.map(function (_a, index) {
        var options = _a.options;
        return (react_1.default.createElement(list_1.List, { type: "option", key: tslib_1.__spread(["initial"], internalValue).slice(0, index + 1).join("$"), onScrollBottom: function () { return onScrollBottom(internalValue.slice(0, index)); } }, options ? (react_1.default.createElement(react_1.default.Fragment, null,
            tips && (react_1.default.createElement(list_1.List.StatusTip, null, tips(internalValue.slice(0, index)))),
            options.map(function (_a) {
                var value = _a.value, label = _a.label, child = _a.child, disabled = _a.disabled;
                var selected = internalValue[index] === value;
                var triggerProps = expandTrigger === "hover" && child
                    ? {
                        onMouseEnter: function (event) {
                            enterTimerRef.current = setTimeout(function () {
                                handleSelect(index, value, {
                                    event: event,
                                    hasChild: true,
                                });
                            }, 150);
                        },
                        onMouseLeave: function () {
                            clearTimeout(enterTimerRef.current);
                        },
                    }
                    : {
                        onClick: function (event) {
                            handleSelect(index, value, {
                                event: event,
                                hasChild: Boolean(child),
                            });
                        },
                    };
                var itemProps = tslib_1.__assign(tslib_1.__assign({}, triggerProps), { key: tslib_1.__spread(internalValue.slice(0, index), [value]).join("/"), disabled: disabled,
                    selected: selected });
                if (child) {
                    return react_1.default.createElement(list_1.List.SubMenu, tslib_1.__assign({}, itemProps, { label: label || value }));
                }
                return react_1.default.createElement(list_1.List.Item, tslib_1.__assign({}, itemProps), label || value);
            }),
            options.length === 0 && (react_1.default.createElement(list_1.List.StatusTip, null,
                react_1.default.createElement(tips_1.EmptyTip, null))),
            bottomTips && (react_1.default.createElement(list_1.List.StatusTip, null, bottomTips(internalValue.slice(0, index)))))) : (react_1.default.createElement(list_1.List.StatusTip, null,
            react_1.default.createElement(CascaderLoading_1.CascaderLoading, { onLoad: function () {
                    return onLoad(internalValue, CascaderBox_1.getOptions(data, internalValue));
                } })))));
    })));
}
exports.CascaderMenuLists = CascaderMenuLists;
CascaderMenuLists.displayName = "CascaderMenuLists";
//# sourceMappingURL=CascaderMenuLists.js.map